<template>
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div class="animate__animated animate__bounceIn">
						<div class="card shadow">
							<div class="card-body text-center">
								<div style="font-size: 200px; font-weight: bold;" class="lh-1">404</div>
								<div style="font-size: 30px;">{{$t('text.404')}}</div>
								<router-link :to="{path: '/'}" class="btn btn-lg btn-primary mt-5">{{$t('btn.goto-main')}}</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Ошибка 404 | KMIB EDU'});
	},
	data: () => ({
		
	}),
	computed: {},
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeMount(){
		document.body.classList.add('exam-bg');
	},
	beforeUnmount(){
		document.body.classList.remove('exam-bg');
	},
	beforeRouteUpdate(to, from, next){
		document.body.classList.add('exam-bg');
		window.scrollTo(0, 0);
		next();
	},
	components: {},
}
</script>